import { Typography, styled } from '@mui/material';

const Subtitle = styled(Typography)({
  fontSize: '1.125rem',
  lineHeight: 1.555,
  marginTop: '1rem',
});

export default Subtitle;
